import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class GuildAndUnion extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      CreateUnions: true,
      GuildsCount: 8,
      UnionChatLimit: 12,
      GuildPenalty: true,
      GPDonating: true,
      PlayerCountG1: 20,
      PlayerCountG2: 30,
      PlayerCountG3: 35,
      PlayerCountG4: 40,
      PlayerCountG5: 50,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Guild and Union Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>Create Unions</td>
              <td>
                <Switch
                  checked={this.state.CreateUnions}
                  {...SwitchOnOff}
                  onChange={this.handleChange('CreateUnions')}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Guilds in an Union</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.GuildsCount}
                  placeholder="Type a count..."
                  onValueChange={this.handleChange('GuildsCount')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Players in Union Chat</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.UnionChatLimit}
                  placeholder="Type a count..."
                  onValueChange={this.handleChange('UnionChatLimit')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Guild Penalty</td>
              <td>
                <Switch
                  checked={this.state.GuildPenalty}
                  {...SwitchOnOff}
                  onChange={this.handleChange('GuildPenalty')}
                />
              </td>
            </tr>

            <tr>
              <td>GP Donating</td>
              <td>
                <Switch
                  checked={this.state.GPDonating}
                  {...SwitchOnOff}
                  onChange={this.handleChange('GPDonating')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild Level 1" className="mb-0">
                  Maximum Player in a Guild
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.PlayerCountG1}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PlayerCountG1')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild Level 2" className="mb-0">
                  Maximum Player in a Guild
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.PlayerCountG2}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PlayerCountG2')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild Level 3" className="mb-0">
                  Maximum Player in a Guild
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.PlayerCountG3}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PlayerCountG3')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild Level 4" className="mb-0">
                  Maximum Player in a Guild
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.PlayerCountG4}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PlayerCountG4')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild Level 5" className="mb-0">
                  Maximum Player in a Guild
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.PlayerCountG5}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PlayerCountG5')}
                  min={0}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
